import React, {useState} from 'react';
import FilterOrderBy from './filters/FilterOrderBy';

function summary(props) {
  const [modalVisible, setModalVisible] = useState(false);

  const {
    layout,
    filters,
    results,
    currentSearchTerm,
    selected,
    mobileStyle,
    displayPostCounts,
    order,
    autoLoadFilters,
    filterReset,
    sidebarLeft,
    sidebarRight,
    displayReset,
    displayResults,
    displaySort,
    displaySearch,
    postType,
    orderChange,
    toggleSelected,
    replaceSelected,
    isSelected,
    resetSelected,
    searchFieldChange,
    setFilterReset
  } = props;

  let totalResults;
  let sortComponent;
  let activeFilters;
  let reset;

  for ( const term in selected ) {
    if ( selected[term].length > 0 ) {
      activeFilters = true;
      break;
    }
  }

  if (displayReset) {
    reset = (
        <a
          className="eight29-reset"
          onClick={() => {
            resetSelected();
          }}
        >
          <span>Clear Filters</span>
        </a>
    );
  }

  if (displayResults && activeFilters) {
    totalResults = <div className="eight29-filter-summary-results">
      <span>We found {results} results</span>
      {reset}
    </div>
  }

  if (displaySort) {
    sortComponent = <FilterOrderBy
        order={order}
        orderChange={orderChange}
        postType={postType}
    ></FilterOrderBy>
  }

  return (
    <div className="eight29-filter-summary">
        {totalResults}
        {sortComponent}
    </div>
  );
}

export default summary;